import { render, staticRenderFns } from "./BugReport.vue?vue&type=template&id=69d21284&scoped=true&lang=pug"
import script from "./BugReport.vue?vue&type=script&lang=js"
export * from "./BugReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d21284",
  null
  
)

export default component.exports